(() => {
  const NOTE_VARIANT_ID = '53609637773648';
  const isEnglish = (document.documentElement.lang || '').toLowerCase().startsWith('en');

  const getSelectedVariantId = (form) => {
    const checked = form.querySelector('input[name="id"]:checked');
    if (checked?.value) return String(checked.value);
    const select = form.querySelector('select[name="id"]');
    if (select?.value) return String(select.value);
    const input = form.querySelector('[name="id"]');
    return input?.value ? String(input.value) : '';
  };

  const translateNoteUi = (form) => {
    if (!isEnglish) return;
    const field = form.querySelector('[data-note-field]');
    const message = form.querySelector('[data-note-message]');
    const toggleText = form.querySelector('.fv__note-toggle span, .fvp__note-toggle span');
    const noteLabel = field?.querySelector('label');
    const helper = field?.querySelector('small');

    if (toggleText) toggleText.textContent = 'Add a personalized note';
    if (noteLabel) noteLabel.textContent = 'Your note';
    if (message) {
      message.placeholder = 'Write the message that will accompany this bouquet…';
      message.name = 'properties[Personalized note]';
    }
    if (helper) helper.textContent = '250 characters maximum. The note will be prepared with this bouquet.';
  };

  const syncForm = (form) => {
    if (!form?.querySelector('[data-note-toggle]')) return;
    const field = form.querySelector('[data-note-field]');
    const toggle = form.querySelector('[data-note-toggle]');
    if (!field || !toggle) return;

    let parentInput = form.querySelector('[data-flowever-note-parent]');
    if (!parentInput) {
      parentInput = document.createElement('input');
      parentInput.type = 'hidden';
      parentInput.name = 'shopify-additional-items[1][parent_id]';
      parentInput.setAttribute('data-note-extra', '');
      parentInput.setAttribute('data-flowever-note-parent', '');
      field.appendChild(parentInput);
    }

    parentInput.value = getSelectedVariantId(form);
    parentInput.disabled = !toggle.checked;
    translateNoteUi(form);
  };

  const syncAll = (scope = document) => {
    scope.querySelectorAll('form').forEach(syncForm);
  };

  const originalFetch = window.fetch.bind(window);
  window.fetch = (input, init) => {
    const requestUrl = typeof input === 'string' ? input : input?.url || '';
    const isCartAdd = /\/cart\/add(?:\.js)?(?:[?#]|$)/.test(requestUrl);

    if (isCartAdd && init && typeof init.body === 'string') {
      try {
        const payload = JSON.parse(init.body);
        if (Array.isArray(payload.items)) {
          const noteLine = payload.items.find((item) => String(item?.id) === NOTE_VARIANT_ID);
          const parentLine = payload.items.find((item) => String(item?.id) !== NOTE_VARIANT_ID);

          if (noteLine && parentLine && !noteLine.parent_id) {
            noteLine.parent_id = parentLine.id;
          }

          if (isEnglish && parentLine?.properties && Object.prototype.hasOwnProperty.call(parentLine.properties, 'Mot personnalisé')) {
            parentLine.properties['Personalized note'] = parentLine.properties['Mot personnalisé'];
            delete parentLine.properties['Mot personnalisé'];
          }

          init = { ...init, body: JSON.stringify(payload) };
        }
      } catch (_error) {
        // Leave non-JSON or unrelated cart requests untouched.
      }
    }

    return originalFetch(input, init);
  };

  document.addEventListener('change', (event) => {
    if (!event.target.matches('[name="id"], [data-note-toggle]')) return;
    syncForm(event.target.closest('form'));
  });

  document.addEventListener('shopify:section:load', (event) => syncAll(event.target));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => syncAll(), { once: true });
  } else {
    syncAll();
  }
})();
